import { render, staticRenderFns } from "./register-enter-password.vue?vue&type=template&id=766ad5a4&"
import script from "./register-enter-password.vue?vue&type=script&lang=js&"
export * from "./register-enter-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports